export default __webpack_public_path__ + "static/media/review-arrow.d2f64bfe.svg";